import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Visual status for graded answers.
 * When the answer key is wrong but the teacher awarded points (score > 0),
 * use `manuallyAwarded` instead of plain `incorrect` so the UI is not red.
 */
export var getAnswerGradingVisualStatus = function getAnswerGradingVisualStatus(_ref) {
  var isCorrect = _ref.isCorrect,
      _ref$isSkipped = _ref.isSkipped,
      isSkipped = _ref$isSkipped === void 0 ? false : _ref$isSkipped,
      _ref$hasAnswer = _ref.hasAnswer,
      hasAnswer = _ref$hasAnswer === void 0 ? true : _ref$hasAnswer,
      score = _ref.score,
      _ref$hasGraded = _ref.hasGraded,
      hasGraded = _ref$hasGraded === void 0 ? false : _ref$hasGraded;

  if (isSkipped) {
    return 'skipped';
  }

  if (!hasAnswer) {
    return 'ungraded';
  }

  if (isCorrect) {
    return 'correct';
  }

  var hasPositiveManualScore = hasGraded && typeof score === 'number' && Number.isFinite(score) && score > 0;

  if (hasPositiveManualScore) {
    return 'manuallyAwarded';
  }

  return 'incorrect';
};
export var isManuallyAwardedAnswer = function isManuallyAwardedAnswer(params) {
  return getAnswerGradingVisualStatus(_objectSpread(_objectSpread({}, params), {}, {
    hasAnswer: true
  })) === 'manuallyAwarded';
};